<template>
	<div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="3"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p>填写信息<span>（4/5）</span></p>
				</div>
				<div class="wrapper-body__body__container"  v-if="!!form.guardian">
					<md-field>
						<md-input-item
							:value="form.student.nativeStreetName"
							disabled
							title="所在街道"
							placeholder="街道设置名称"
							:maxlength="40"
						></md-input-item>
						<md-input-item
							v-show="form.student.nativeVillageName"
							:value="form.student.nativeVillageName"
							disabled
							title="所在社区"
							placeholder="社区设置名称"
							:maxlength="40"
						></md-input-item>
						<md-field-item
							title=""
							:placeholder="placeholderTextSchool"
							arrow="arrow-right"
							:addon="form.orderSchoolName"
							@click="isSchoolPickerShow = true">
						</md-field-item>
						<md-picker
							ref="schoolPicker"
							v-model="isSchoolPickerShow"
							:data="schoolsData"
							@confirm="onSchoolPickerConfirm()"
							title="选择幼儿园"
						></md-picker>

						<!-- 招生简章 -->
						<div class="box-school-info" v-if="hasSchoolData">
							<div style="color:#888;padding-bottom:20px;">该学校报名情况 {{numberInfo}}</div>
							<div class="text-h4 title">招生简章</div>
							<div>
								<p v-html="currentSchoolInfo" style="white-space: pre-line;"></p>
							</div>
              <p>温馨提示：<span v-if="detailObj.updateNumber!==undefined&&detailObj.updateNumber!==''">提交成功后，仅允许修改幼儿园 {{detailObj.updateNumber}} 次，请慎重考虑后再操作！</span>请带上相关资料在预约时间到指定幼儿园进行资料审查</p>
            </div>
						<div v-else class="box-school-info">
							<p class="text-error" style="text-align:center;">当前街道社区没有幼儿园数据！</p>
						</div>

						<!-- <md-field-item
							title=""
							arrow="arrow-right"
							@click="showAddress2 = !showAddress2"
							placeholder="请选择街道社区"
							:content="pickerValue2"
							solid
						/>
						<md-picker
							ref="streetPicker"
							title="请选择"
							v-model="showAddress2"

							:default-value="[]"

							:data="lqStreets"
							:cols="2"
							is-cascade
							@confirm="onPickerConfirm()"
							@change="handleChange"
						></md-picker> -->
					</md-field>
				</div>
			</div>
			<div class="wrapper-body__footer">
				<div class="box-btns">
					<span class="button-primary" @touchstart="handlePreviousStep">上一步</span>
					<span class="button-primary-inset"
						@touchstart="handleNextStep">下一步</span>
				</div>
				<!-- <div><router-link :to="{path: 'bm_login', query: {signupNoticeId: $route.query.signupNoticeId}}">同意并遵守</router-link></div> -->
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageForm from '../index/mixins/page_bm_form';
  import MdRadio from '../../../node_modules/mand-mobile/components/radio/index.vue';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: { MdRadio },
    data() {
      return {
        detailObj:{},

        showAddress2: false,
				pickerValue2: '',
				lqStreets: [],

				placeholderTextSchool: '请选择幼儿园',
				isSchoolPickerShow: false,
				schoolsData: [],
				currentSchoolInfo: '',
				numberInfo:'',
				hasSchoolData: true // 没有幼儿园数据时 设置为 false
			}
		},
		computed: {
			addressName() {
				let { nativeStreetName, nativeVillageName } = this.form.student;
				let addressName = '';
				if (nativeStreetName) {
					addressName = addressName + nativeStreetName;
				}

				if (nativeVillageName) {
					addressName = addressName + ' ' + nativeVillageName;
				}

				return addressName;
			}
		},

    async mounted() {
      // window.step4 = this;
      // 1. 更新formData
      this.updateFormData();
      this.getSignUpDetailById();
			console.log('[-> Step4] Form ::', this.form);
			let { orderSchoolName } = this.form;
			let { nativeStreetCode, nativeVillageCode } = this.form.student;

			let { data } = await this.getSchoolData({ streetCode: nativeStreetCode, villageCode: nativeVillageCode });

			if (data) {
				let schools = this.formatSchoolData(data);
				this.schoolsData.push(schools);
			}

			if (orderSchoolName) {
				this.placeholderTextSchool = '';
				let currentSchool = this.schoolsData[0].find(v => v.text === orderSchoolName);
				// 当前街道社区幼儿园列表 没有已选择的学校
				if (!currentSchool) {
					this.form.orderSchoolName = '';
					this.placeholderTextSchool = '请选择幼儿园';
				} else {
					this.currentSchoolInfo = currentSchool.introduction;
					this.numberInfo = `学位：${currentSchool.studentNum}  已报：${currentSchool.successNum}`;
				}
			}
      // 2. 转换formData中的某些字段到当前视图中
      // todo
    },
		methods: {
      async getSignUpDetailById() {
        // 根据报名通知ID查询报名通知信息 #敬瑞/2021-05-12#
        let {data} = await this.$ajax.gateway("/bm-kids/ISignupNoticeApi_getInfoById_3", {
          "METHOD": "get",
          "signupNoticeId": this.$route.query.signupNoticeId
        });
        this.detailObj = data.data.signupNoticeDomain
      },

			handleNextStep() {
        let { form, $message } = this;

        // 2.转换formData格式，使数据格式和后端的保持一致（需要的才处理）
				// form[xxx] = xxx;
				if (!form.orderSchoolName) {
					return this.$message.error('请选择幼儿园！');
				}

        // 3.保存formData到sessionStorage中
        this.saveFormData(form);

        // 4.跳转路由
				this.$router.push({
					path: 'step5_time',
					query: this.$route.query
				});
			},

			onSchoolPickerConfirm() {
				let values = this.$refs['schoolPicker'].getColumnValues()
				console.log('-> 选择幼儿园', values);

				let value = values[0];

				if (this.form.orderSchoolName != value.text) {
					this.form.signupQuotaId = '';
				}

				this.placeholderTextSchool = '';
				this.form.orderSchoolName = value.text;
				this.form.orderSchoolId = value.value;

				// 切换学校后 获取招生简章
				this.currentSchoolInfo = value.introduction;
				this.numberInfo = `学位：${value.studentNum}  已报：${value.successNum}`;
			},

			async getSchoolData({ streetCode, villageCode }) {
				// // 报名端-根据街道CODE查询学校列表 #李茹钰/2019-03-12#
				// let { data, error } = await this.$ajax.gateway('/bm-kids/ISchoolApi_searchSchool', {
				// 	METHOD: 'get',
				// 	signupNoticeId: this.$route.query.signupNoticeId,
				// 	streetCode,
				// 	villageCode
				// });
				// 报名端-根据街道CODE查询幼儿园列表 #李茹钰/2020-06-02#
				let {data,error} = await this.$ajax.gateway("/bm-kids/ISchoolApi_searchSchoolByAreaCode_1", {
					"METHOD": "get",
					signupNoticeId: this.$route.query.signupNoticeId,
					streetCode,
					villageCode
				});
				if (data) {
					if (!data.data || data.data.length <= 0) {
						this.$message.error('没有幼儿园数据！');
						this.hasSchoolData = false;
					}
					return data;
				} else {
					this.$message.error('获取学校列表失败！');
					return { data: null };
				}
			},

			formatSchoolData(data) {
				return data.map(v => {
					return {
						'text': v.name,
						'value': v.id,
						'introduction': v.introduction,
						successNum:v.successNum,
						studentNum:v.studentNum
					}
				});
			},

			// onPickerConfirm(index) {
			//   const compt = this.$refs['streetPicker'];
      //   const values = compt.getColumnValues();
      //
      //   let res = '';
      //   values.forEach(value => {
      //     value && (res += `${value.text || value.label} `)
      //   });
      //   console.log(values, '确认街道、社区');
			// 	this['pickerValue2'] = res;
      //
			// 	console.log('更改预约时间');
			// 	if (values[0] && this.form.guardian.streetCode != values[0].code) {
			// 		sessionStorage.setItem('form_orderDate', '');
			// 		this.form.signupQuotaId = '';
			// 	}
      //
      //   let form = this.form;
      //
      // // // 51 四川省 5101 成都市 510112 龙泉驿区
      //   form.guardian.provinceCode = '51';// values[0].code;
      //   form.guardian.provinceName = '四川省';// values[0].name;
      //
      //   form.guardian.cityCode = '5101';// values[1].code;
      //   form.guardian.cityName = '成都市';// values[1].name;
      //
      //   form.guardian.areaCode = '510112';// values[2].code;
      //   form.guardian.areaName = '龙泉驿区';// values[2].name;
      //
      //   form.guardian.streetCode = values[0].code;// values[3].code;
      //   form.guardian.streetName = values[0].name;// values[3].name;
      //
      //   form.orderStreetCode = values[0].code;
      //   form.orderStreetName = values[0].name;
      //
      //   form.guardian.villageCode = values[1] ? values[1].code : '';
      //   form.guardian.villageName = values[1] ? values[1].name : '';
      //
      //   form.areaCode = '510112';// values[0].code;
      //   form.areaName = '龙泉驿区';// values[0].name;
			// },

			handleChange({ options }) {
				this.address = options
			}
		}
  }
</script>

<style lang="stylus" scoped>
	.box-sub-checked
		padding-left 40px
	.box-item
		margin-top 30px
	.box-school-info
		padding .2rem
		.title
			text-align center
			min-height auto
	.body-mobile
		>>> .md-field-item
			.md-field-item-title
				width 1.5rem
			.md-input-item-input
				text-align right
				text-overflow: ellipsis;
</style>
